import type React from "react";
import {Skeleton, Stack, Typography} from "@mui/material";

type TaxonomyBuilderHowToProps = {
    /** Two skeleton lines (the text's usual height) while the taxonomy loads, like the KPI pills above. */
    isLoading: boolean;
};

/** How to work with the builder, under the KPI pills. Keep it in step with what the tree view offers. */
export const TaxonomyBuilderHowTo: React.FC<TaxonomyBuilderHowToProps> = ({isLoading}) => isLoading ? (
    <Stack>
        <Skeleton variant="text" width="100%" sx={{fontSize: theme => theme.typography.caption.fontSize}}/>
        <Skeleton variant="text" width="60%" sx={{fontSize: theme => theme.typography.caption.fontSize}}/>
    </Stack>
) : (
    <Typography variant="caption" color="text.secondary">
        Click a category to show or hide its sub-categories, or find one with the level filters and the
        L1–Ln buttons. Hover a category to add a sub-category or delete it, click its name to rename it, and
        drag it onto another category to move it there. Use Merge to combine categories under the same parent.
        Every change is saved straight away and can be undone. When you're done, review your changes with
        Send for approval.
    </Typography>
);
